
export const getRatio = {
  methods: {
    getRatio () {
      if (this.$terminal === 'IOS') {
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.callNativeRatio.postMessage(null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getRatio.js